import tw, { styled } from "twin.macro";

export const Wrapper = styled.div`
	${tw`p-0! bg-white w-full container relative`}
	min-height: 50vh !important;
	height: 100%;
`;
